export default {
	path: '/logistics-info',
	meta: {
		title: '物流信息',
	},
	component: r => require.ensure([], () => r(require(`./index.vue`)), `/logistics-info`),
}



// WEBPACK FOOTER //
// ./src/views/LogisticsInfo/router.js